import {ControlledFormField, FormFieldBase} from '@hconnect/common/types'
import {FeatureFlagKey, useCommonFeatureFlag} from '@hproduce/feature-flags'
import {FieldValues} from 'react-hook-form'

import {ProcessStageSearchField} from './ProcessStageSearchField'
import {ProcessStageSelectField} from './ProcessStageSelectField'

type Props<TField extends FieldValues> = FormFieldBase &
  ControlledFormField<TField> & {
    plantId: string
    onChange?: (value: string | undefined) => void
  }

export const ProcessStageField = <TField extends FieldValues>(props: Props<TField>) => {
  const {plantId, ...restProps} = props
  const isProcessStageAutocompleteEnabled =
    useCommonFeatureFlag(FeatureFlagKey.AutocompleteProcessStage, {plantId}) ?? false

  return isProcessStageAutocompleteEnabled ? (
    <ProcessStageSearchField {...restProps} plantId={plantId} />
  ) : (
    <ProcessStageSelectField {...restProps} plantId={plantId} />
  )
}
